import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(console.warn)
}

VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(console.warn)
}

const lazyLoading = (folderName) => () => import(/* webpackChunkName: "page-" */`../pages/${folderName}/index.vue`)

const routes = [{
  path: '/tour-ring/:buildingId',
  name: 'tour-ring',
  component: lazyLoading('TourRing')
}, {
  path: '/login',
  name: 'login',
  component: lazyLoading('Login')
}, {
  path: '/signup',
  name: 'signup',
  component: lazyLoading('Signup')
}, {
  path: '/:buildingId?',
  name: 'default',
  component: lazyLoading('Default')
}, {
  path: '/:buildingId/yung-ching',
  name: 'yung-ching',
  component: lazyLoading('YungChing')
}]

const routerObj = {
  routes,
  mode: 'history',
  linkActiveClass: 'active'
}

const router = new VueRouter(routerObj)

export default router
